export const samoletAuthConfig = {
  crypto: 'SHA-256',
  responseType: 'code',
  scope: 'openid profile email',
  codeChallengeMethod: 'S256',
  grantType: {
    code: 'authorization_code',
    refresh: 'refresh_token',
  },
  authProdStandUrl: 'id.samoletgroup.ru',
  authStageStandUrl: 'id-stage.samoletgroup.ru',
  links: {
    auth: `https://:stand/oauth2/authorize/`,
    complete: '/oauth2/authorize/complete',
    token: 'https://:stand/oauth2/token/',
    jwt: 'https://:stand/oauth2/jwt/',
    logout: 'https://:stand/accounts/logout/',
    register: 'https://:stand/accounts/register/',
  },
};
